define('boxes/box',['jquery', 'all/comeon', 'boxes/helpers/box-loading'], function ($, comeon, boxLoading) {
    'use strict';

    return {
        create: function ($box, $controller, view, model) {
            var localVariables = {
                $box: $box,
                $controller: $controller,
                view: $.extend({}, this.view, view),
                model: $.extend({}, this.model, model)
            };
            var instance = comeon.create(this.api, localVariables);
            instance.model.init(instance);
            return instance;
        },
        api: {
            render: function (boxInstance) {
                var renderPromise = comeon.promise.create(),
                    beforeRenderPromises = boxInstance.model.beforeRender(boxInstance);

                comeon.promise.when(beforeRenderPromises)
                    .done(function () {
                        boxInstance.view.render(boxInstance);
                        boxInstance.model.afterRender(boxInstance);
                        renderPromise.resolve();
                    })
                    .fail(function () {
                        renderPromise.reject();
                    });
                return renderPromise.promise();
            },
            close: function(boxInstance) {
                boxInstance.model.close(boxInstance);
            },
            box: function () {
                return this.$box;
            }
        },
        view: {
            render: function () {
                console.log('view.render() not implemented.');
            }
        },
        model: {
            init: function () {
                console.log('model.init() not implemented');
            },
            beforeRender: function () {
                console.log('model.beforeRender() not implemented');
                return [];
            },
            afterRender: function () {
                console.log('model.afterRender() not implemented');
            },
            close: function () {
            }
        },
        ajax: function (boxInstance, settings, fn) {
            boxLoading.showLoading(boxInstance.$box);
            var ajaxPromise = comeon.promise.create();
            $.ajax(settings)
                .done(function (data) {
                    fn(data, ajaxPromise);
                })
                .fail(function () {
                    ajaxPromise.reject();
                })
                .always(function () {
                    boxLoading.removeLoading(boxInstance.$box);
                });
            return ajaxPromise;
        }
    };
});
